import * as React from 'react';

import {
  ModalFrame,
  ModalFrameFooter,
  ModalFrameInner,
  ModalFrameMessage
} from 'components/modal';

import FacebookButton from '../../FacebookButton';
import FacebookButtonHelp from '../../common/help/FacebookButtonHelp';

import { __t, applyTranslations } from 'utils/language';

import './facebook-button-modal.scss';

applyTranslations(require('./facebook-button-modal.i18n.json'));

import type {
  FacebookButtonModalType
} from '../types';

interface Props {
  type: FacebookButtonModalType
}

const MSG_KEY = 'facebook_button_modal';

const FacebookButtonModal: React.FC<Props> = ({
  type
}: Props) => {
  const getTitle = (): string => (
    __t(`${MSG_KEY}.${type}.title`)
  );

  const renderBody = (): React.ReactNode => (
    <React.Fragment>
      {
        type === 'login' && (
          <React.Fragment>
            <div className="facebook-button-modal__salutation">
              {__t(`${MSG_KEY}.login.salutation`)},
            </div>
            <div>
              {__t(`${MSG_KEY}.login.body`)}
            </div>
          </React.Fragment>
        )
      }
      {
        type === 'expired' && (
          <div>
            {__t(`${MSG_KEY}.expired.body`)}
          </div>
        )
      }
    </React.Fragment>
  );

  return (
    <div className="facebook-button-modal">
      <ModalFrame
        title={getTitle()}
      >
        <ModalFrameMessage
          message={renderBody()}
          className="facebook-button-modal__message"
        />
        <ModalFrameInner
          className="facebook-button-modal__inner"
        >
          <FacebookButton
            isCentered
          />
        </ModalFrameInner>
        <ModalFrameFooter>
          <FacebookButtonHelp />
        </ModalFrameFooter>
      </ModalFrame>
    </div>
  );
};

export default FacebookButtonModal;
